const { tabletPx } = require('../../scss/_variables.scss').default;

export const matchMediaTablet = window.matchMedia(`(min-width: ${tabletPx})`);
